import { useCallback } from 'react';
import { RoundStatus } from '@pascal/pascal-core';

import { animationDefaultDelays } from '../enums/animations';

const mainAnimationDelay = 5000;
const betsClosedDuration = 1000;
const useAnimationDelay = ({ roundStatus, gameAnimationDelay = null }) => {
  const calculatedAnimationDelay = useCallback(
    (name) => {
      let animationDelay;
      if (gameAnimationDelay === null && roundStatus !== RoundStatus.OnFinish) {
        animationDelay = animationDefaultDelays[name];
      } else {
        if (roundStatus === RoundStatus.Started) {
          if (gameAnimationDelay > 0) {
            animationDelay =
              animationDefaultDelays[name] -
              (mainAnimationDelay - gameAnimationDelay) +
              betsClosedDuration;
          }
          if (gameAnimationDelay <= 0) {
            animationDelay =
              animationDefaultDelays[name] -
              (mainAnimationDelay - gameAnimationDelay) +
              gameAnimationDelay -
              betsClosedDuration;
          }
        } else if (roundStatus === RoundStatus.OnHold) {
          animationDelay =
            animationDefaultDelays[name] -
            mainAnimationDelay +
            gameAnimationDelay -
            betsClosedDuration;
        }
      }

      return {
        animationDelay: `${animationDelay}ms`,
      };
    },
    [gameAnimationDelay, animationDefaultDelays, roundStatus]
  );
  return {
    calculatedAnimationDelay,
  };
};

export { mainAnimationDelay, useAnimationDelay };
